// Self-Service Vetting Engine Types v1.0.1
export var ESSVNode;
(function (ESSVNode) {
    ESSVNode["REQUIREMENT"] = "Requirement";
    ESSVNode["ASSESSMENT"] = "Assessment";
})(ESSVNode || (ESSVNode = {}));
export var ESSVOutcome;
(function (ESSVOutcome) {
    ESSVOutcome["APPROVED"] = "Approved";
    ESSVOutcome["REJECTED"] = "Rejected";
    ESSVOutcome["PIPELINE"] = "Pipeline";
})(ESSVOutcome || (ESSVOutcome = {}));
export var ESSVRunnerState;
(function (ESSVRunnerState) {
    ESSVRunnerState["WAITING"] = "Waiting";
    ESSVRunnerState["READY"] = "Ready";
    ESSVRunnerState["RUNNING"] = "Running";
    ESSVRunnerState["COMPLETE"] = "Complete";
    ESSVRunnerState["INVALID"] = "Invalid";
    ESSVRunnerState["ERROR"] = "Error";
})(ESSVRunnerState || (ESSVRunnerState = {}));
